export const LOCALES = {
  UZBEK: "uz",
  RUSSIAN: "ru",
};
